import Vue from 'vue';
import { IDictionary } from '@/entities/dictionary.interface';
import { IFormControl } from '@/entities/form.interface';
import queryService from '@/services/query.service';
import { FormComponent } from '../form/form.component';

export abstract class FormFilterComponent extends FormComponent {
    // for emit values
    public abstract search(payload: any);

    public abstract defaultFormValues(): IDictionary<any>;
    public abstract getQueryObject(formState: IDictionary<IFormControl>): any;

    protected submit() {
        const query = this.buildQuery(this.formState);
        queryService.pushCriteriaChanges(this.$route, this.$router, query);
    }

    protected doSearch() {
        this.initFormStateFromRoute(this.formState, this.$route);
        const query = this.getQueryObject(this.formState);
        if (query == null) {
            return;
        }
        this.search(query);
    }

    protected clear() {
        queryService.pushClearParams(this.$route, this.$router);
        // const defValues = this.defaultFormValues();
        // Object.keys(this.formState).forEach((key) => {
        //     this.formState[key].value = defValues[key];
        // });
        // this.submit();
    }

    protected initFormStateFromRoute(
        formState: IDictionary<IFormControl>,
        $route
    ) {
        const initial: IDictionary<string> = $route.query;
        const defValues = this.defaultFormValues();

        Object.keys(formState).forEach((key) => {
            if (initial.hasOwnProperty(key)) {
                const value = formState[key].mapper
                    ? formState[key].mapper.parse(initial[key])
                    : initial[key];
                formState[key].value =
                    value !== null && value !== undefined
                        ? value
                        : defValues[key];
            } else {
                formState[key].value = defValues[key];
            }
        });
    }

    protected buildQuery(
        formState: IDictionary<IFormControl>
    ): IDictionary<string> {
        let query = {
            rand: Date.now().toString()
        };
        Object.keys(formState).forEach((key) => {
            const formItem = formState[key];
            query[key] = formItem.mapper
                ? formItem.mapper.toString(formItem.value)
                : formItem.value;
        });
        return query;
    }
}
